import React from "react";
import mapServiceItem from "./mapServiceItem";

export default function ProductionGallery({ items }) {
    const galleryItems = items.map(mapServiceItem);
    const [featuredGalleryItem, ...secondaryGalleryItems] = galleryItems;

    return (
        <div className="production-gallery">
            {featuredGalleryItem ? (
                <article className="production-gallery-card production-gallery-feature" key={featuredGalleryItem.title}>
                    <img src={featuredGalleryItem.text} alt={featuredGalleryItem.title} />
                    <div>
                        <span>{featuredGalleryItem.marker}</span>
                        <h3>{featuredGalleryItem.title}</h3>
                    </div>
                </article>
            ) : null}
            <div className="production-gallery-side">
                {secondaryGalleryItems.map((card) => (
                    <article className="production-gallery-card" key={card.title}>
                        <img src={card.text} alt={card.title} />
                        <div>
                            <span>{card.marker}</span>
                            <h3>{card.title}</h3>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
}
